export const conditionalRuleConstants = {
    NONE: 'NONE',
    DEFAULT_MAX: 100,
    DEFAULT_MIN: 0,
    DEFAULT_MIN_VAL: '0',
    OPERATOR_DROPDOWN_OPTIONS: [
        { id: '-1', label: '', value: '' },
        { id: '0', label: 'Less Than', value: 'LESS_THAN' },
        { id: '1', label: 'Less Than Or Equal To', value: 'LESS_THAN_OR_EQUAL' },
        { id: '2', label: 'Equal To', value: 'NUMBER_EQUALS' },
        { id: '3', label: 'Not Equal To', value: 'NUMBER_NOT_EQUALS' },
        { id: '4', label: 'Greater Than Or Equal To', value: 'GREATER_THAN_OR_EQUAL' },
        { id: '5', label: 'Greater Than', value: 'GREATER_THAN' }
    ],
    OPERATOR_PART_PRICE_COMPARISON_DROPDOWN_OPTIONS: [
        { id: '1', label: '', value: '' },
        { id: '2', label: 'Equal To', value: 'NUMBER_EQUALS' },
        { id: '3', label: 'Not Equal To', value: 'NUMBER_NOT_EQUALS' },
        { id: '4', label: 'Greater Than Or Equal To', value: 'GREATER_THAN_OR_EQUAL' },
        { id: '5', label: 'Greater Than', value: 'GREATER_THAN' }
    ],
    LOSS_TYPE: 'Loss Type',
    LOSS_TYPE_DISPLAY_NAMES: {
        A: 'Animal',
        C: 'Collision',
        M: 'Comprehensive',
        F: 'Fire',
        H: 'Hail',
        L: 'Liability',
        E: 'Mechanical Inspection',
        O: 'Other',
        P: 'Property',
        I: 'Single Interest',
        T: 'Theft',
        U: 'Unknown',
        V: 'Vandalism',
        S: 'Water/Flood/Submersion',
        Q: 'Other Than Collision'
    },
    VEHICLE_AGE_ODOMETER_VARIABLES: {
        CARD_TITLE: 'Vehicle Age/Vehicle Odometer',
        VEHICLE_AGE_MILEAGE_CHECKBOXES: 'VehicleAgeMileageCheckboxes',
        VEHICLE_AGE_ODOMETER_CONTROL_VARIABLES: {
            AGE_THRESHOLD: 'AgeThreshold',
            MILEAGE_THRESHOLD: 'MileageThreshold',
            AND_OR_RADIOS: 'AndOrRadios',
            VEHICLE_AGE: 'VehicleAge',
            VEHICLE_ODOMETER: 'VehicleOdometer'
        },
        VEHICLEODOMETER_CHECKBOX_VEHICLEAGEVEHICLEODOMETER: 'Vehicle Odometer',
        VEHICLEAGE_CHECKBOX_VEHICLEAGEVEHICLEODOMETER: 'Vehicle Age',
        AND_RADIO: 'And',
        OR_RADIO: 'Or',
        VEHICLE_ID_PREFIX: {
            AGE: 'Age',
            MILEAGE: 'Mileage'
        }
    },
    APPLIED: 'Applied',
    NOTAPPLIED: 'Not Applied',
    CONTROLS_VARIABLE_TEXT: {
        INPUT_CONTROL: 'numeric_input_value-textbox',
        OPERATOR_DROPDOWN: 'drpDown_Operator',
        ARRAYTYPE_DROPDOWN: 'dropdown-selection-list',
        CHECKBOX: 'Checkbox'
    },
    VEHICLE_DETAILS_VARIABLES: {
        CARD_TITLE: 'Vehicle Details',
        CONTROLS_DISABLED: new Set(['ADD', 'MODEL']),
        PARENT_CONTROLS: { MODEL: 'make', YEAR: 'year', MAKE: 'make' },
        ADD: 'Add',
        YEAR: 'Year',
        MAKE: 'Make',
        MAKE_ID: 'makeId',
        MODEL: 'Model',
        ANY: 'Any',
        DEFAULT_SELECTED_VALUE: 'ANYYEAR_ANYMAKE_ANYMODEL',
        MESSAGE: 'Conditional Rules that contain the Vehicle Details card may not run for Non-Mitchell estimates.',
        DEFAULT_YEAR_MAKE_MODEL: () => ({
            index: 0,
            year: 'Any',
            make: 'Any',
            makeId: '0',
            model: 'Any'
        }),
        DEFAULT_YEAR_MAKE_MODEL_VALUE: () => ({
            index: 0,
            year: '0',
            make: '0',
            makeId: '0',
            model: '0'
        })
    },
    ESTIMATEPROFILE_EDITS_VARIABLES: {
        CARD_TITLE: 'Estimate Profile Edits',
        CONTROLS_DISABLED: new Set(['ADD', 'SECTION', 'FIELD']),
        PARENT_CONTROLS: { TAB: 'tab', SECTION: 'section', FIELD: 'field' },
        FIELD_LIST_TITLE: ['Group', 'Section', 'Estimate Field'],
        ADD: 'Add',
        TAB: 'Tab',
        GROUP: 'Group',
        SECTION: 'Section',
        FIELD: 'Field',
        ESTIMATE_FIELD: 'Estimate Field',
        ANY: 'Any',
        MESSAGE: 'Rule only runs on the fields under Labor/Tax Rules, Calculations and Adjustments.',
        FIELD_LIST: ['tab', 'section', 'field'],
        DEFAULT_TAB_SECTION_FIELD: () => ({
            index: 0,
            tab: 'Any',
            tabCode: 'Any',
            section: 'Any',
            sectionCode: 'Any',
            field: 'Any',
            fieldCode: 'Any',
            ciecaCode: 'Any'
        })
    },
    MANAGE_CONDITIONAL_RULES_SEARCH_INPUT_ID: 'MANAGE_CONDITIONAL_RULES_SEARCH_INPUT_ID',
    MANAGE_CONDITIONAL_RULES_SEARCH_PLACE_HOLDER: 'Search Rule',
    COMPLIANCE_RULES_SELECTED_RULE: 'selectedRule',
    COMPLIANCE_RULES_EDIT_RULE: 'editRule',
    COMPLIANCE_RULES_GRID_HEADER_WIDTH_IN_PERCENTAGE_3: 3,
    COMPLIANCE_RULES_GRID_HEADER_WIDTH_IN_PERCENTAGE_4: 4,
    COMPLIANCE_RULES_GRID_HEADER_WIDTH_IN_PERCENTAGE_5: 5,
    COMPLIANCE_RULES_GRID_HEADER_WIDTH_IN_PERCENTAGE_10: 10,
    COMPLIANCE_RULES_GRID_HEADER_WIDTH_IN_PERCENTAGE_13: 13,
    COMPLIANCE_RULES_GRID_HEADER_WIDTH_IN_PERCENTAGE_15: 15,
    COMPLIANCE_CONDITIONAL_RULES_SELECT_ALL_CHECKBOX: 'selectAllConditionalRulesId',
    COMPLIANCE_RULES_RULES_NAME: 'Rule Name',
    COMPLIANCE_RULES_RULES_NAME_KEY: 'ruleName',
    COMPLIANCE_RULES_RULE_DESCRIPTION: 'Description',
    COMPLIANCE_RULES_RULE_DESCRIPTION_KEY: 'ruleDescription',
    COMPLIANCE_RULES_CREATED_BY: 'Created By',
    COMPLIANCE_RULES_CREATED_BY_KEY: 'createdBy',
    COMPLIANCE_RULES_CREATED_DATE: 'Created Date',
    COMPLIANCE_RULES_CREATED_DATE_KEY: 'createdDate',
    COMPLIANCE_RULES_UPDATED_BY: 'Updated By',
    COMPLIANCE_RULES_UPDATED_BY_KEY: 'updatedBy',
    COMPLIANCE_RULES_UPDATED_DATE: 'Updated Date',
    COMPLIANCE_RULES_UPDATED_DATE_KEY: 'updatedDate',
    COMPLIANCE_RULES_REQUIRED: 'Req',
    COMPLIANCE_RULES_REQUIRED_KEY: 'isRequired',
    COMPLIANCE_RULES_HIDDEN: 'Hid',
    COMPLIANCE_RULES_HIDDEN_KEY: 'isHidden',
    COMPLIANCE_RULES_ESCALATED: 'Esd',
    COMPLIANCE_RULES_ESCALATED_KEY: 'isEscalated',
    COMPLIANCE_RULES_CRITICAL: 'Crt',
    COMPLIANCE_RULES_CRITICAL_KEY: 'isCritical',
    COMPLIANCE_RULES_EDIT: 'Edit',
    COMPLIANCE_RULES_REQ_CONFIRM_ICON_ID: 'req_confirm_icon_id',
    COMPLIANCE_RULES_HID_CONFIRM_ICON_ID: 'hid_confirm_icon_id',
    COMPLIANCE_RULES_ESD_CONFIRM_ICON_ID: 'esd_confirm_icon_id',
    COMPLIANCE_RULES_CRT_CONFIRM_ICON_ID: 'crt_confirm_icon_id',
    COMPLIANCE_RULES_RULE_DESC_MAX_LENGTH: 80,
    COMPLIANCE_RULES_RULE_NAME_MAX_LENGTH: 45,
    COMPLIANCE_RULES_NO_CONDITIONAL_RULES_CUSTOM_ROW: 'No Conditional Rules have been created.',
    COMPLIANCE_CONDITIONAL_RULES_DATA_GRID_ID: 'compliance-manage-conditional-rules-grid',
    EDIT_BUTTON_ID: 'manage_conditional_rule_edit_button_id',
    MANAGE_CONDITIONAL_RULES_DELETE_BUTTON: 'Delete Rule(s)',
    MANAGE_CONDITIONAL_RULES_ADD_BUTTON: 'Create New Rule',
    MANAGE_CONDITIONAL_RULES_DELETE_CONFIRMATION_LABEL: 'Deleted rules will be removed from any profiles that the rule is assigned to. Do you want to delete?',
    MANAGE_CONDITIONAL_RULES_DELETE_CONFIRMATION_HEADER: 'Delete Conditional Rule',
    MANAGE_CONDITIONAL_RULES_DELETE_CONFIRMATION_PRIMARY_BUTTON_LABEL: 'Delete Rule',
    COMPLIANCE_PROFILE_DELETE_MODAL_TERTIARY_LABEL: 'Cancel',
    COMPLIANCE_CONDITIONAL_RULES_PAGE_SIZE: 40,
    COMPLIANCE_MANAGE_CONDITIONAL_RULE_HEADER: 'Conditional Rule Manager',
    MANAGE_CONDITIONAL_RULE_CREATE_BUTTON_ID: 'manage-conditional-profile_add-button',
    MANAGE_CONDITIONAL_RULE_DELETE_BUTTON_ID: 'manage-conditional-profile_delete-button',
    MARKUP_DISCOUNT_CARD_TITLE: 'Markup/Discount',
    PART_PRICE_COMPARISON_TITLE: 'Part Price Comparison',
    PRE_TAX_DISCOUNT_TITLE: 'Pre-Tax Discount',
    PART_PROFILE_CHECK_TITLE: 'Parts Profile Check',
    BETTERMENT_CARD_TITLE: 'Betterment',
    PART_PRICE_CARD_TITLE: 'Part Price',
    PAINT_MATERIAL_RATE_CARD_TITLE: 'Paint Materials Rate',
    REGEX_FOR_PERCENT_IN_BETTERMENT: '^(\\d{0,2}\\.\\d{1,4}|\\d{1,2}|\\d{0})$',
    REGEX_FOR_CURRENCY: '^(\\d{0,5}\\.\\d{1,2}|\\d{1,5}|\\d{0})$',
    REGEX_FOR_EURO_CURRENCY: '^(\\d{0,5}\\,\\d{1,2}|\\d{1,5}|\\d{0})$',
    REGEX_FOR_YEAR: '^(\\d{0,3})$',
    REGEX_FOR_MILES: '^(\\d{0,7})$',
    REGEX_FOR_HOURS: '^(\\d{0,2}\\.\\d{1}|\\d{1,2}|\\d{0})$',
    REGEX_FOR_MARK_DISC_PERCENT: '^(-?\\d{0,3}\\.\\d{1,4}|-?\\d{1,3}|\\d{0})$',
    PART_DETAILS: {
        CARD_TITLE: 'Part Details',
        SELECT_PARTS: 'Select Parts:',
        SELECTED_PARTS: 'Selected Parts',
        LABOR_OPERATION: 'Labor Operation',
        LABOR_RATE: 'Labor Rate',
        PART_TYPE: 'Part Type',
        ANY_OPTION: 'Any',
        PARTS_PROPERTY: 'parts',
        LABOR_OPERATIONS_PROPERTY: 'laborOperations',
        LABOR_RATE_PROPERTY: 'laborRateTypes',
        PART_TYPE_PROPERTY: 'partTypes'
    },
    PERCENT_SYMBOL: '%',
    LINE_TYPE_VARIABLES: {
        MESSAGE: 'By default, conditional rules are evaluated both on CEG and Manual Lines, use this card to limit the rule to one of the options',
        TITLE: 'Line Type',
        MESSAGE_ID: 'LineType-WarningMessage'
    },
    PARTS_PROVIDER: {
        CARD_TITLE: 'Parts Provider',
        CARD_ID: 'PartsProvider',
        MULTISELECT_PLACEHOLDER: 'Select at least one carrier',
        MULTISELECT_SUBTEXT: 'Selected'
    },
    INSURANCE_CARRIERS: {
        CARD_TITLE: 'Insurance Carrier',
        CARD_ID: 'InsuranceCarriers',
        MULTISELECT_PLACEHOLDER: 'Select at least one carrier',
        MULTISELECT_SUBTEXT: 'Selected'
    },
    PARTS_PROVIDERS_LIST: {
        '28': 'LKQ Corporation',
        '29': 'OnPart',
        '4': 'MAPP',
        '5': 'QRP',
        '20': 'APU',
        '30': 'Car-Part',
        '22': 'PartsTrader',
        '27': 'Progi'
    },
    DOLLAR_RADIO: 'Dollar ($)',
    PRETEXT_FOR_DOLLAR: 'Fail if the difference between the actual part price and cheapest alternate part price is',
    STATE_ZIP_CODE_VARIABLES: {
        STATE_ZIP_CODE_CONTROL_VARIABLES: {
            STATE_ZIP_CHECKBOXES: 'StateZipCheckboxes',
            STATES: 'SelectedStates',
            ZIP_CODES: 'SelectedZipCode',
            STATE_TYPE: 'StateType',
            ZIP_CODE_TYPE: 'ZipCodeType',
            AND_OR_RADIOS: 'AndOrRadios'
        },
        EN_CARD_TITLE: 'State/Zip Code',
        CA_CARD_TITLE: 'Province/Postal Code',
        STATE_LABEL: 'State',
        PROVINCE_LABEL: 'Province',
        ZIP_CODE_LABEL: 'Zip Code',
        POSTAL_CODE_LABEL: 'Postal Code',
        AND_RADIO: 'And',
        OR_RADIO: 'Or',
        MAX_ZIP_CODES_ALLOWED: 50,
        SELECTED: 'Selected',
        ZIP_CODES_ENTERED: 'Zip Codes Entered (Max 50)',
        POSTAL_CODES_ENTERED: 'Postal Codes Entered (Max 50)',
        VALIDATION_MESSAGE_CANADA: 'Invalid Postal Code',
        VALIDATION_MESSAGE_US: 'Invalid Zip Code',
        STATE_PLACEHOLDER: "Select the state and press 'enter key'",
        PROVINCE_PLACEHOLDER: "Select the province and press 'enter key'",
        ZIP_CODE_PLACEHOLDER: "Type the zip code and press 'enter key'",
        POSTAL_CODE_PLACEHOLDER: "Type the postal code and press 'enter key'",
        ALL_STATES_LABEL: 'All States',
        ALL_PROVINCES_LABEL: 'All Provinces'
    },
    NO_OPTIONS_MESSAGE: 'No options',
    BETTERMENT_ADJUSTMENT_ARRAY: 'AdjustmentArray',
    CONFIRM_ICON: 'mi-icon-confirm',
    EDIT_ICON: 'mi-icon-edit',
    INITIAL_RULE_VERSION: 1.0,
    COMPLIANCE_CONDITIONAL_RULES_NO_RESULTS_ID: 'compliance-manage-conditional-rules_no-results-found',
    MARK_AS_FINAL_TITLE: 'Mark As Final',
    MARK_FINAL_DISPLAY_NAMES: {
        F: 'Marked As Final',
        E: 'Not Marked As Final'
    },
    CONDITIONAL_RULE_SEVERITY_DATAKEY: 'severity',
    CONDITIONAL_RULE_REVIEWER_OPTION_DATAKEY: 'reviewerOption',
    CONDITIONAL_RULE_COMMENT_FOR_WARNING_DATAKEY: 'commentRequiredForOptionalInd',
    CONDITIONAL_RULE_RESULT_TYPE: 'Result Type',
    CONDITIONAL_RULE_REVIEWER_OPTION_TYPE: 'Reviewer Option',
    CONDITIONAL_RULE_COMMENT_FOR_WARNING: 'Comment for Warning?',
    COMPLIANCE_RULES_ESCALATED_TITLE: 'Escalated',
    COMPLIANCE_RULES_HIDDEN_TITLE: 'Hidden',
    NO_RESULTS_FOUND: 'No results found',
    REPAIR_STATUS_TITLE: 'Repair Status',
    REPAIR_STATUS_DISPLAY_NAMES: {
        ArrivalDateTime: 'Arrived at Shop',
        DisassemblyDateTime: 'Disassembly',
        ActualStartDate: 'Repair in Progress',
        InPaintShopDateTime: 'Paint',
        ActualCompletionDateTime: 'Ready for Delivery',
        ActualPickUpDateTime: 'Delivered',
        ScheduledArrivalDateTime: 'Due In Date',
        TargetCompletionDateTime: 'Estimated Completion Date'
    },
    COMPLIANCE_RULES_GRID_HEADER_WIDTH_IN_PERCENTAGE_12: 12,
    COMPLIANCE_RULES_GRID_HEADER_WIDTH_IN_PERCENTAGE_8: 8,
    MANAGE_COMPLIANCE_PROFILE: 'Compliance Profiles',
    MANAGE_COMPLIANCE_PROFILE_BACK_BUTTON_ID: 'conditional_rule_compliance_profile_back_button_id',
    COMPLIANCE_PROFILE_BACK_URL: '/ComplianceProfileManager/ComplianceProfiles.aspx#/',
    PROPERTY_DAMAGE_LIMIT_CARD_TITLE: 'Property Damage Limit'
};
//# sourceMappingURL=conditionalRuleConstants.js.map